<script setup lang="ts">
   import { useAuth0 } from '@auth0/auth0-vue';
   import { useRuntimeConfig } from '#imports';
   import { resolveAuthRedirectUri } from '~/functions/appOrigin';

   const { isAuthenticated, loginWithRedirect, isLoading } = useAuth0() ?? {};
   const config = useRuntimeConfig();

   /**
    * Gets the login search param from the url to set custom Auth0 "ext-portal" authorization param
    */
   function login() {
      const urlParams = new URLSearchParams(location.search);
      const portal = urlParams.get('login') || 'ipapolo';
      loginWithRedirect({
         authorizationParams: {
            'ext-portal': portal,
            redirect_uri: resolveAuthRedirectUri(config.public.auth0Domain as string),
         },
      });
   }
</script>

<template>
   <button
      v-if="!isAuthenticated && !isLoading"
      @click="login"
      class="flex items-center justify-center border border-white bg-brand-title px-7 py-3 uppercase text-white">
      Learner Portal
   </button>
</template>

<style scoped></style>
